import { Component, OnInit ,Output, ViewChild, Input,EventEmitter} from '@angular/core';

@Component({
  selector: 'lib-principal-dasboard-lib',
  templateUrl: './principal-dasboard-lib.component.html',
  styleUrls: ['./principal-dasboard-lib.component.scss']
})
export class PrincipalDasboardLibComponent implements OnInit {
  @Input() data;
  
  @Output() userSelectedDate = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    console.log(" IN --> 7 data");
  }
  onUserSelectDate(e:any){
    console.log(" IN --> 1");
    // this.data = null;
    
    this.userSelectedDate.emit(e);
  }
  
}
